
<!--Synthesis Section-->
<section *ngIf="header && title" class="section">
  <div class="container">
    <div class="offset-1 col-10">
      <app-title [header]="header" [title]="title" priority="3" underline></app-title>

      <br/>
    </div>

    <div class="offset-1 col-10">
      <ng-content></ng-content>
    </div>

  </div>
</section>
